import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { useActivityNoun } from "../activity-context";

interface NameChangeChunkProps {
  change: ActivityChange;
}

export function NameChangeChunk({ change }: NameChangeChunkProps) {
  const name = useActivityNoun().toLowerCase();

  if (!change.oldValue?.value) {
    return (
      <Text size="sm">
        set this {name}'s name to <Text size="sm">{change.newValue?.value}</Text>
      </Text>
    );
  }
  if (!change.newValue?.value) {
    return <Text size="sm">cleared this {name}'s name</Text>;
  }
  return (
    <Text size="sm">
      renamed this {name} from <Text size="sm">{change.oldValue.value}</Text> to{" "}
      <Text size="sm">{change.newValue.value}</Text>
    </Text>
  );
}
